import { YStack, Text } from 'tamagui'
import type { SectionDividerSlide as SectionDividerSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner } from './shared'

export function SectionDividerSlide({ slide }: { slide: SectionDividerSlideType }) {
  return (
    <SlideContainer>
      <SlideInner alignItems="center" style={{ padding: 'clamp(32px, 6vw, 80px)' }}>
        <Text
          fontFamily="$accent"
          color="$orangePrimary"
          letterSpacing={6}
          style={{
            fontSize: 'clamp(48px, 10vw, 120px)',
            lineHeight: '1em',
            textShadow: '0 0 40px #FF630030',
          }}
        >
          {slide.sectionNumber}
        </Text>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color="$textPrimary"
          textAlign="center"
          style={{ fontSize: 'clamp(28px, 4vw, 56px)', lineHeight: '1.2em' }}
        >
          {slide.title}
        </Text>
        {slide.subtitle && (
          <Text
            fontFamily="$mono"
            color="$textMuted"
            textAlign="center"
            style={{ fontSize: 'clamp(12px, 1.5vw, 18px)' }}
          >
            {slide.subtitle}
          </Text>
        )}
        {slide.timeEstimate && (
          <Text
            fontFamily="$mono"
            color="$orangeSecondary"
            marginTop="$4"
            style={{ fontSize: 'clamp(11px, 1.2vw, 16px)', letterSpacing: '2px' }}
          >
            {slide.timeEstimate}
          </Text>
        )}
      </SlideInner>
    </SlideContainer>
  )
}
